<template>
  <div class="row">
    <div class="flex xs12">
      <va-card title="学员offer">
        <div class="row align--center mb-1">
          <div class="flex xs12 sm6">
            <va-input
              class="ma-0"
              :value="name"
              placeholder="search by name"
              @input="search"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
          <div class="flex xs12 sm6">
            <div class="d-flex justify--end">
              <va-button color="info" small :to="{ name: 'saveStudentOffer' }">新增学员offer</va-button>
            </div>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="filteredData"
          :loading="loading"
          :totalPages="totalPages"
          @page-selected="listOffer"
          api-mode
        >
          <template slot="avatar" slot-scope="props">
            <img :src="props.rowData.avatar" class="data-table-server-pagination---avatar" alt="avatar">
          </template>
          <template slot="offer" slot-scope="props">
            <img :src="props.rowData.offerImageUrl" class="data-table-server-pagination---avatar" alt="avatar">
          </template>
          <template slot="sort" slot-scope="props">
            <va-input
              v-model="props.rowData.sortNum"
              type="number"
              :min="1"
            >
              <va-button slot="append" icon="ion-md-checkmark ion" color="info" small @click="updateSortNum(props.rowData)">
              </va-button>
            </va-input>
          </template>
          <template slot="actions" slot-scope="props">
            <va-button flat small color="gray" icon="fa fa-pencil"
              :to='{path:`updateStudentOffer/${props.rowData.id}`}'/>
            <va-button flat small color="gray" icon="fa fa-trash"
              @click="deleteModal = true;deleteId=props.rowData.id"/>
          </template>
        </va-data-table>

        <va-modal
          v-model="deleteModal"
          title="删除学员offer"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />

      </va-card>
    </div>
  </div>
</template>

<script>

import debounce from 'lodash/debounce'
import studentOfferApi from '../../api/studentOffer'

export default {
  data () {
    return {
      message: ['Required field'],
      serviceId: 3,
      offers: [],
      name: '',
      loading: true,
      pageSize: 10,
      totalPages: 1,
      deleteModal: false,
      deleteId: null,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:avatar',
          width: '60px',
        }, {
          name: 'name',
          title: '学员姓名',
          width: '10%',
        },
        {
          name: '__slot:sort',
          title: '排序',
          width: '10%',
        },
        {
          name: 'background',
          title: '学员背景',
          width: '20%',
        },
        {
          name: 'joinedProject',
          title: '参与项目',
          width: '15%',
        },
        {
          name: '__slot:offer',
          width: '60px',
        },
        {
          name: 'offer',
          title: '项目收获',
          width: '20%',
        },
        {
          name: '__slot:actions',
          width: '10%',
          dataClass: 'text-left',
        },
      ]
    },
    filteredData () {
      if (!this.name || this.name.length < 1) {
        return this.offers
      }
      return this.offers.filter(item => {
        return item.name.toLowerCase().startsWith(this.name.toLowerCase())
      })
    },
  },
  created () {
    this.listOffer()
  },
  methods: {
    listOffer (pageNumber = 1) {
      this.loading = true
      const params = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
      }
      studentOfferApi.listStudentOffer(params)
        .then(response => {
          this.offers = response.studentOffers
          this.totalPages = response.totalPage
          this.loading = false
        })
    },
    confirmDelete () {
      if (this.deleteId === null) return
      studentOfferApi.deleteStudentOffer(this.deleteId).then(response => {
        if (response.success === true) {
          this.listOffer()
        }
      }).catch(error => alert(error))
    },
    search: debounce(function (name) {
      this.name = name
    }, 400),
    updateSortNum: function (params) {
      studentOfferApi.updateStudentOffer(params.id, params).then(response => {
        if (response.success === true) {
          this.listOffer()
        }
      }).catch(error => alert(error))
    },
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 5%;
}
</style>
